<ul>
	<li *ngFor="let d of dates">{{ toLocalFormat(d) }}</li>
</ul>
